import { useParams } from 'react-router';
import React from 'react';
import useVirtualMedicine from '../../../apis/virtual-medicines/hooks/useVirtualMedicine';
import { Loading } from '../../../healtheraComponents';
import VirtualMedicine from '../components/VirtualMedicine';

interface RouteParams {
  virtualMedicineId: string;
  masterMedicineId: string;
}

const VirtualMedicineContainer = () => {
  const { virtualMedicineId: id, masterMedicineId } = useParams<RouteParams>();

  const { virtualMedicine, isLoading } = useVirtualMedicine(id);

  if (isLoading) {
    return <Loading />;
  }

  if (id !== 'create' && !virtualMedicine) {
    return <div>Virtual medicine not found</div>;
  }

  return <VirtualMedicine masterMedicineId={masterMedicineId} virtualMedicine={virtualMedicine} />;
};

export default VirtualMedicineContainer;
